// Quick add for CETO cards: add in place, refresh the cart count, show "Added".
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[data-ceto-quickadd]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('.ceto-quickadd__btn');
  const label = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const res = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    document.querySelectorAll('#cart-icon-bubble').forEach((bubble) => {
      let count = bubble.querySelector('.cart-count-bubble');
      if (!count) {
        count = document.createElement('div');
        count.className = 'cart-count-bubble';
        count.innerHTML = '<span aria-hidden="true"></span>';
        bubble.appendChild(count);
      }
      count.querySelector('span').textContent = cart.item_count;
    });
    button.textContent = 'Added ✓';
    button.classList.add('is-added');
  } catch (err) {
    button.textContent = err.message.length < 40 ? err.message : 'Try again';
  } finally {
    setTimeout(() => {
      button.disabled = false;
      button.textContent = label;
      button.classList.remove('is-added');
    }, 2200);
  }
});
